export default __webpack_public_path__ + "static/media/tractor.eca30062.png";